export default __webpack_public_path__ + "static/longImage-41caf55a74b8e0bf72f3cd108ec0c1af.jpg";